import _ from 'lodash'
const VIDEO_YOUTUBE_CONFIG = {
    videos: _.selectAll( '.c-video--youtube' ),
    params: {
        origin: `${window.location.protocol}//${window.location.host}`,
        host: `${window.location.protocol}//www.youtube.com`,
        controls: false,
        rel: 0,
        modestbranding: 1,
        iv_load_policy: 3,
        showinfo: 0,
        color: 'white',
        muted: false,
        controls: false
    }
}
export default VIDEO_YOUTUBE_CONFIG